module.exports = __webpack_public_path__ + "static/img/7.707ca43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/7.png
// module id = Cykd
// module chunks = 0